(function () {
  var SUPPRESS_KEY = 'suppressInStock';
  var SUPPRESS_COLLECTION_KEY = 'suppressInStockCollection';
  var AVAILABILITY_PARAM = 'filter.v.availability';
  var COLLECTION_PATTERN = /^\/collections\/([^\/?]+)\/?$/;
  var FILTERED_COLLECTIONS = window.instockFilterCollections || [];
  var CURRENT_COLLECTION = window.instockCurrentCollection || {};

  function getCollectionHandle(pathname) {
    var match = COLLECTION_PATTERN.exec(pathname);
    return match ? match[1] : null;
  }

  function isFilteredCollection(pathname) {
    var handle = getCollectionHandle(pathname);
    return !!handle && FILTERED_COLLECTIONS.indexOf(handle) !== -1;
  }

  function getCurrentAvailabilityCount(pathname) {
    if (CURRENT_COLLECTION.handle !== getCollectionHandle(pathname)) return -1;
    var count = Number(CURRENT_COLLECTION.availabilityCount);
    return Number.isFinite(count) ? count : -1;
  }

  function hasInStockProducts(pathname) {
    return getCurrentAvailabilityCount(pathname) > 0;
  }

  function setSuppressCollection() {
    sessionStorage.setItem(SUPPRESS_KEY, 'true');
    sessionStorage.removeItem(SUPPRESS_COLLECTION_KEY);
  }

  function clearSuppressCollection() {
    sessionStorage.removeItem(SUPPRESS_KEY);
    sessionStorage.removeItem(SUPPRESS_COLLECTION_KEY);
  }

  function isSuppressedCollection(pathname) {
    if (sessionStorage.getItem(SUPPRESS_KEY) !== 'true') return false;
    var handle = getCollectionHandle(pathname);
    var suppressedHandle = sessionStorage.getItem(SUPPRESS_COLLECTION_KEY);
    return suppressedHandle ? suppressedHandle === handle : true;
  }

  function applyInStockFilter() {
    var pathname = window.location.pathname;

    if (!isFilteredCollection(pathname)) {
      if (sessionStorage.getItem(SUPPRESS_KEY) === 'true') clearSuppressCollection();
      return;
    }

    var params = new URLSearchParams(window.location.search);

    if (params.has(AVAILABILITY_PARAM)) {
      clearSuppressCollection();
    } else if (isSuppressedCollection(pathname)) {
      clearSuppressCollection();
    } else if (hasInStockProducts(pathname)) {
      params.set(AVAILABILITY_PARAM, '1');
      window.location.replace(pathname + '?' + params.toString());
    }
  }

  applyInStockFilter();

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) applyInStockFilter();
  });

  document.addEventListener('click', function (event) {
    var activeFacetLink = event.target.closest('.active-facets a, facet-remove a');
    if (!activeFacetLink) return;

    var url;
    try { url = new URL(activeFacetLink.href, window.location.origin); } catch (_) { return; }
    if (!url.searchParams.has(AVAILABILITY_PARAM) && isFilteredCollection(url.pathname)) {
      setSuppressCollection();
    }
  });
})();
